export default __webpack_public_path__ + "static/media/Work-Day-Scheduler-img-2.81e977a8.gif";